import { render, staticRenderFns } from "./editorTiptap.vue?vue&type=template&id=67703eae&"
import script from "./editorTiptap.vue?vue&type=script&lang=js&"
export * from "./editorTiptap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports